export default __webpack_public_path__ + "static/media/text_texture.44963fca.webp";